var map = {
	"./arrow-right.png": "3846",
	"./avatar.png": "1195",
	"./bg.png": "d68e",
	"./file.jpg": "3bd8",
	"./file/PDF.svg": "eeaf",
	"./file/png.svg": "7cbf",
	"./file/txt.svg": "b2b8",
	"./file/word.svg": "d930",
	"./file/xls.svg": "8d4d",
	"./login/bg.jpg": "57f7",
	"./login/logo.png": "ceca",
	"./logo.png": "cf05",
	"./success.svg": "2764"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";